import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import AppointmentDateTimeContainer from '../../../../components/AppointmentDateTime/AppointmentDateTimeContainer.js';
import { getBookAppointmentStore } from '../../data/book-appointment-store.js';
import { getBookAppointmentType } from '../../data/book-appointment-type.js';
import { MissingStoreIdError, AlternativeUrlStoreError, MissingTypeIdError, InvalidVirtualAppointmentError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError, AlternativeLinkedAppointmentTypeNotValidError } from '../../errors.js';
import { getFormattedParams, hasValidVirtualAppointmentParams, generateVirtualAppointmentStoreData, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from '../../utils.js';

const WhenRoot = ()=>{
    return /*#__PURE__*/ React.createElement(AppointmentDateTimeContainer, null);
};
WhenRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        if (formattedParams.storeId === undefined) {
            throw MissingStoreIdError();
        }
        if ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId)) {
            throw AlternativeUrlStoreError();
        }
        if (formattedParams.typeId === undefined) {
            throw MissingTypeIdError();
        }
        let promises = [
            null,
            null
        ];
        if (hasValidVirtualAppointmentParams(formattedParams)) {
            const type = yield getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
            promises = [
                type ? generateVirtualAppointmentStoreData(formattedParams.virtualStoreCode, type) : null,
                type, 
            ];
        } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        } else {
            promises = [
                getBookAppointmentStore(apolloClient, formattedParams.storeId, locale, formattedParams.tryInStoreFlow),
                getBookAppointmentType(apolloClient, formattedParams.typeId, locale), 
            ];
        }
        const [store, type] = yield Promise.all(promises);
        if (!store) {
            throw StoreNotFoundError();
        } else if (!type) {
            throw TypeNotFoundError();
        } else if (type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !isAppointmentTypeValid({
            typeId: formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId,
            store
        })) {
            throw LinkedAppointmentTypeNotValidError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.alternativeLinkedAppointmentTypeId) && !isAppointmentTypeValid({
            typeId: formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.alternativeLinkedAppointmentTypeId,
            store
        })) {
            throw AlternativeLinkedAppointmentTypeNotValidError();
        }
        let timeSlot = null;
        if (formattedParams.start && formattedParams.end) {
            timeSlot = {
                from: formattedParams.start,
                until: formattedParams.end
            };
        }
        return Promise.resolve({
            store,
            type,
            timeSlot
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

export { WhenRoot as default };
//# sourceMappingURL=WhenRoot.js.map
